[
  {
    "name": "deVere Group Channel",
    "href": "http://www.youtube.com/user/deveregroupchannel",
    "iconName": "fa-brands fa-youtube"
  },
  {
    "name": "deVere Group",
    "href": "https://www.facebook.com/deVereGroup/",
    "iconName": "fa-brands fa-facebook-f"
  },
  {
    "name": "@deveregroup",
    "href": "https://twitter.com/deveregroup",
    "iconName": "fa-brands fa-x-twitter"
  },
  {
    "name": "deVere Group",
    "href": "http://www.linkedin.com/company/devere-group",
    "iconName": "fa-brands fa-linkedin"
  },
  {
    "name": "deveregroup",
    "href": "http://www.instagram.com/deveregroup/",
    "iconName": "fa-brands fa-instagram"
  }
]